import { queryStorefrontApi } from './queryStorefrontApi';

/*
 * Mirrors Shopify's url redirects onto the headless domain.
 *
 * Superfiliate registers every affiliate's vanity link as a Shopify redirect
 * (/CODE -> their landing page or /discount/CODE link), but Shopify only serves
 * those on the "Online Store" domain, so clearlyfiltered.com/CODE would 404
 * here. Looking the path up per request instead of at build time keeps up with
 * affiliates joining without needing a redeploy.
 * @see https://help.superfiliate.com/articles/2185449010-using-superfiliate-with-headless-storefront
 */

const URL_REDIRECTS_QUERY = `
  query UrlRedirects($query: String!) {
    urlRedirects(first: 10, query: $query) {
      nodes {
        path
        target
      }
    }
  }
`;

export const getShopifyRedirect = async (path) => {
  if (!path) return null;

  // `path:` is a prefix search, so the match is narrowed down below
  const { body } = await queryStorefrontApi(URL_REDIRECTS_QUERY, {
    query: `path:${JSON.stringify(path)}`,
  });

  const nodes = body?.urlRedirects?.nodes;

  if (!nodes?.length) return null;

  // affiliates share their code in whatever casing they like, so an exact match
  // wins but a casing-only difference still resolves
  const redirect =
    nodes.find((node) => node.path === path) ||
    nodes.find((node) => node.path.toLowerCase() === path.toLowerCase());

  return redirect?.target || null;
};
